module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-aichi-4-b599f862d87f1edbafdd6ef42fa6a0f2.jpg";